export type GetSplitProductNameReturnType = {
    lastWord: string;
    nameWithoutLastWord: string;
}

export const getSplitProductName = (name: string): GetSplitProductNameReturnType => {
    const splitName = name.split(' ');
    const nameWithoutLastWord = splitName.slice(0, -1).join(' ');
    const lastWord = splitName.at(-1) || '';

    return { lastWord, nameWithoutLastWord };
};
